enum UpgradeType {
  A380_FIRST = 'A380_FIRST',
  FIRST = 'FIRST',
  RDMPT_A380_FIRST = 'RDMPT_A380_FIRST',
  RDMPT_787_FIRST = 'RDMPT_787_FIRST',
  RDMPT_FIRST = 'RDMPT_FIRST',
  A380_BUSINESS = 'A380_BUSINESS',
  BUSINESS = 'BUSINESS',
  REGIONAL_BUSINESS = 'REGIONAL_BUSINESS',
  BUSINESS_DOMESTIC = 'BUSINESS_DOMESTIC',
  RDMPT_A380_BUSINESS = 'RDMPT_A380_BUSINESS',
  RDMPT_787_BUSINESS = 'RDMPT_787_BUSINESS',
  RDMPT_BUSINESS = 'RDMPT_BUSINESS',
  RDMPT_REGIONAL_BUSINESS = 'RDMPT_REGIONAL_BUSINESS',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
  REGIONAL_PREMIUM_ECONOMY = 'REGIONAL_PREMIUM_ECONOMY',
  LONGHAUL_PREMIUM_ECONOMY = 'LONGHAUL_PREMIUM_ECONOMY',
  SEAT_FRONT = 'SEAT_FRONT',
  SEAT_LEGROOM = 'SEAT_LEGROOM',
  SEAT_PREMIUM = 'SEAT_PREMIUM',
  SEAT_EXIT = 'SEAT_EXIT',
  ECONOMY_PLUS = 'ECONOMY_PLUS',
  ECONOMY_COUCH = 'ECONOMY_COUCH',
  ECONOMY = 'ECONOMY',

  // Neighbour Free
  EXTRA_SEAT = 'EXTRA_SEAT',
}

export default UpgradeType;
